import React, { useEffect, useState } from "react";
import {
  Grid2,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import CustomIcon from "../../Components/CustomIcon";
import FullScreenDialog from "../../Components/FullScreenDialog";
import CloseButton from "../../Components/CloseButton";
import { PrimaryTooltip } from "../../Components/StyledComponent";
import NonOperationalAccordion from "./components/NonOperationalAccordion";
import { getTagValueStats } from "../../Api/TagsApi";

const NonOperationalBreakdown = ({ globalFilters }) => {
  const [open, setOpen] = useState(false);
  const [nonOperationalStats, setNonOperationalStats] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formatNonOperationalBreakdown = (data) => {
    return data.map((item) => {
      const depots = (item?.depot_breakup || []).map(depot => ({
        label: depot.name,
        count: depot.entity_count
      }))

      return {
        label: item.valueDisplayName,
        depots,
      }
    });
  }

  const fetchNonOperationalBreakdown = async () => {
    const entityType = 'battery';
    const tagCode = 'sub_status';
    const tagValueStatsResponse = await getTagValueStats(globalFilters, entityType, tagCode, 'overview');
    const formattedData = formatNonOperationalBreakdown(tagValueStatsResponse?.response?.data || []);
    setNonOperationalStats(formattedData);
  }

  useEffect(() => {
    if (open) {
      fetchNonOperationalBreakdown();
    }
  }, [open, globalFilters]);

  return (
    <Box>
      <Box onClick={handleOpen}>
      <PrimaryTooltip title="Breakdown by Reason">
        <CustomIcon
          name="dashboard-icon"
          sx={{ color: "#686868", cursor: "pointer", '&:hover': { color: "#4D44D8" } }}
        />
      </PrimaryTooltip>
      </Box>
      <FullScreenDialog
        open={open}
        handleClose={handleClose}
        containerStyles={{
          overflowY: "auto",
          overflowX: "hidden",
          ml: "auto",
          width: "calc(100%/3)",
        }}
      >
        <Box sx={{ p: 3 }}>
          <Grid2
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="fw500s20c000000" sx={{ lineHeight: "20px" }}>
              Non-Operational Vehicles
            </Typography>
            <CloseButton onClick={handleClose} />
          </Grid2>
          <Divider sx={{ borderColor: "#E4E4E4", my: 2 }} />
          <Box>
            {nonOperationalStats.map((data, index) => (
              <NonOperationalAccordion
                key={index}
                title={data.label}
                depots={data.depots}
                showBorder={index !== nonOperationalStats.length - 1}
                globalFilters={globalFilters}
              />
            ))}
          </Box>
        </Box>
      </FullScreenDialog>
    </Box>
  );
};

export default NonOperationalBreakdown;
